<admin-kpi-common [title1]="title" [title2]="title2" [kpiGetData]="kpigetdata" [kpiGetDetail]="kpigetdetail"
    [exportTable]="exportTable" [noDecimalLink]="false">
</admin-kpi-common>